import PageTitle from "components/PageTitle/PageTitle";
import PageFrame from "components/Panels/PageFrame";
import SalaryListWrapper from "./SalaryListWrapper";

const SalaryList = () => {
  return (
    <PageFrame
      children={
        <div>
          <PageTitle titleText="급여관리" />
          <SalaryListWrapper />
        </div>
      }
    />
  );
};
export default SalaryList;
